
const DB_NAME = 'TransBCTN_FS_Persistence';
const STORE_NAME = 'handles';
const HANDLE_KEY = 'root_folder_handle';

export const handleStorage = {
    async getHandle(): Promise<FileSystemDirectoryHandle | null> {
        return new Promise((resolve) => {
            try {
                const request = indexedDB.open(DB_NAME, 1);
                request.onupgradeneeded = () => {
                    request.result.createObjectStore(STORE_NAME);
                };
                request.onsuccess = () => {
                    const db = request.result;
                    if (!db.objectStoreNames.contains(STORE_NAME)) {
                        resolve(null);
                        return;
                    }
                    const tx = db.transaction(STORE_NAME, 'readonly');
                    const store = tx.objectStore(STORE_NAME);
                    const getRequest = store.get(HANDLE_KEY);
                    getRequest.onsuccess = () => resolve(getRequest.result || null);
                    getRequest.onerror = () => resolve(null);
                };
                request.onerror = () => resolve(null);
            } catch (e) {
                resolve(null);
            }
        });
    },

    async saveHandle(handle: FileSystemDirectoryHandle): Promise<void> {
        return new Promise((resolve, reject) => {
            try {
                const request = indexedDB.open(DB_NAME, 1);
                request.onupgradeneeded = () => {
                    request.result.createObjectStore(STORE_NAME);
                };
                request.onsuccess = () => {
                    const db = request.result;
                    const tx = db.transaction(STORE_NAME, 'readwrite');
                    const store = tx.objectStore(STORE_NAME);
                    store.put(handle, HANDLE_KEY);
                    tx.oncomplete = () => resolve();
                    tx.onerror = () => reject(tx.error);
                };
                request.onerror = () => reject(request.error);
            } catch (e) {
                reject(e);
            }
        });
    },

    async clearHandle(): Promise<void> {
        return new Promise((resolve, reject) => {
            try {
                const request = indexedDB.open(DB_NAME, 1);
                request.onsuccess = () => {
                    const db = request.result;
                    if (!db.objectStoreNames.contains(STORE_NAME)) {
                        resolve();
                        return;
                    }
                    const tx = db.transaction(STORE_NAME, 'readwrite');
                    const store = tx.objectStore(STORE_NAME);
                    store.delete(HANDLE_KEY);
                    tx.oncomplete = () => resolve();
                    tx.onerror = () => reject(tx.error);
                };
                request.onerror = () => reject(request.error);
            } catch (e) {
                reject(e);
            }
        });
    }
};
